import React from 'react';
import styles from "../../../HeaderContainer.module.scss";
import {UserNotificationModel} from "../../../../../../../models/responses/message.model";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faTimes,
    faCrown,
    faHandshake,
    faMessage,
    faListCheck,
    faCheck,
    faPlay,
    faRotate,
    faStop,
    faTriangleExclamation,
    faRight,
    faPause,
    faLocationPin,
    faStopwatch,
    faLightEmergencyOn
} from "@fortawesome/pro-light-svg-icons";
import {Label} from "semantic-ui-react";
import {useDispatch} from "react-redux";
import * as taskActions from "../../../../../../../store/actions/task.actions";
import * as authActions from "../../../../../../../store/actions/authorization.actions";
import * as teamActions from "../../../../../../../store/actions/team.actions";
import * as projectActions from "../../../../../../../store/actions/project.actions";
import {useAllTaskListSelector} from "../../../../../../../store/selectors/task/task.selectors";
import FirebaseUsage from "../../../../../../../firebase/firebase.usage";
import {COLLECTIONS} from "../../../../../../../firebase/constants";

export default function NotificationItem(props: {notification: UserNotificationModel}) {
    const {notification} = props;
    const [time, setTime] = React.useState(new Date().getTime() / 1000);
    const allTasks = useAllTaskListSelector();
    const dispatch = useDispatch();

    const selectIcon = () => {
        switch (notification.title) {
            case 'New tagged message':
                return <FontAwesomeIcon icon={faMessage} size="lg" />;
            case 'Task started':
                return <FontAwesomeIcon icon={faPlay} size="lg" />;
            case 'New issue':
                return <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />;
            case 'Waiting to start':
                return <FontAwesomeIcon icon={faStopwatch} size="lg" />;
            case 'Task restarted':
                return <FontAwesomeIcon icon={faRotate} size="lg" />;
            case 'Task blocked':
                return <FontAwesomeIcon icon={faStop} size="lg" />;
            case 'Task suspended':
                return <FontAwesomeIcon icon={faPause} size="lg" />;
            case 'Task completed':
                return <FontAwesomeIcon icon={faCheck} size="lg" />;
            case 'Task approved':
                return <FontAwesomeIcon icon={faCheck} size="lg" />;
            case 'Task forecast changed':
                return <FontAwesomeIcon icon={faLocationPin} size="lg" />;
            case 'Checklist item completed':
                return <FontAwesomeIcon icon={faListCheck} size="lg" />;
            case 'Checklist item unchecked':
                return <FontAwesomeIcon icon={faTimes} size="lg" />;
            case 'Taskforce Join':
                return <FontAwesomeIcon icon={faHandshake} size="lg" />;
            case 'Task owner added':
                return <FontAwesomeIcon icon={faCrown} size="lg" />;
            case 'Task owner removed':
                return <FontAwesomeIcon icon={faCrown} size="lg" />;
            case 'Task critical':
                return <FontAwesomeIcon icon={faLightEmergencyOn} size="lg" />;
            default:
                return null;
        }
    }

    const howLongAgo = (timestamp: number) => {
        const timeDiff = Math.floor((time - timestamp) / 60);
        const days = Math.floor(timeDiff / 1440);
        const hours = Math.floor((timeDiff % 1440) / 60);
        const minutes = timeDiff % 60;
        const seconds = timeDiff % 60;
        if (days > 0) {
            return `${days} day${days > 1 ? 's' : ''} ago`;
        } else if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        } else if (minutes > 0) {
            return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        } else if (seconds > 0) {
            return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
        } else {
            return 'Just now';
        }
    }

    const registerClick = async () => {
        if (!notification.clicked) {
            await FirebaseUsage.updateDoc(COLLECTIONS.USER_NOTIFICATIONS, notification.uuid!, {
                clicked: FirebaseUsage.timestamp()
            })
        }
    }

    return (
        <div
            key={notification.uuid}
            className={styles.NotificationItem}
            onClick={() => {
                registerClick().catch(e => console.error(e));
                const task = allTasks.get(notification.taskId);
                if (!task) return;
                dispatch(taskActions.Actions.setActiveTask(task));
                dispatch(taskActions.Actions.setGoToTask(true));
                dispatch(authActions.Actions.setUserSidebarOpen(false));
                dispatch(authActions.Actions.setUserNotificationsOpen(false))
                dispatch(projectActions.Actions.setLedgerOpen(true))
            }}
        >
            {!notification.clicked ? <div className={styles.NotificationNovelty}></div> :
                <div className={styles.NotificationClicked}></div>
            }
            <div className={notification.clicked ? styles.NotificationItemIconClicked :
                notification.seen ? notification.seen.seconds > time ? styles.NotificationItemIcon :
                    styles.NotificationItemIconSeen :
                    styles.NotificationItemIcon}>
                {selectIcon()}
            </div>
            <span className={styles.NotificationItemContent}>
                <div className={styles.NotificationItemTitle}>{notification.title}</div>
                <p className={styles.NotificationItemBody}>{notification.body}</p>
                {notification.text && <p><i>"{notification.text}"</i></p>}
                <div className={styles.NotificationTaskLabel}>
                    <Label content={`${notification.taskCode ? `${notification.taskCode} - ` : ''}${notification.taskName}`} />
                </div>
                <div className={styles.NotificationItemTime}>{howLongAgo(notification.timestamp.seconds)}</div>
            </span>
        </div>
    );
}